import moment from "@/utils/moment";
import APIMixin from "@/mixins/APIMixin";
import numberMixin from "@/mixins/numberMixin";

const requestBody = APIMixin.methods;
const valueInCents = val => numberMixin.methods.currencyInCents(val);
const discountField = "fee";

function couponValue(value_type, value) {
  return value_type == "VALUE"
    ? valueInCents(value)
    : parseFloat(value.replace(",", "."));
}

function buildAttributes(payload) {
  return {
    name: payload.name.toUpperCase(),
    value: couponValue(payload.value_type, payload.value),
    value_type: payload.value_type,
    coupon_type: payload.coupon_type,
    max_usage: buildMaxUsage(payload.max_usage),
    min_applicable_value: valueInCents(payload.min_applicable_value),
    max_applicable_value: valueInCents(payload.max_applicable_value),
    max_discount_value: valueInCents(payload.max_discount_value),
    expires_at: moment(payload.expires_at).toISOString(),
    discount_field: discountField
  };
}

function buildMaxUsage(payload) {
  return {
    total: parseInt(payload.total),
    per_customer: parseInt(payload.per_customer),
    per_professional: parseInt(payload.per_professional),
    per_district: parseInt(payload.per_district)
  };
}

function createRequestBody(payload) {
  return {
    data: {
      type: "coupons",
      attributes: buildAttributes(payload)
    }
  };
}

function updateRequestBody(payload) {
  return {
    data: {
      type: "coupons",
      id: payload.id,
      attributes: {
        max_usage: buildMaxUsage(payload.max_usage),
        expires_at: moment(payload.expires_at).toISOString()
      }
    }
  };
}

function updateProfessionalCouponBody(coupon) {
  return {
    data: {
      type: "coupons",
      id: coupon.id,
      attributes: {
        max_usage: buildMaxUsage({
          total: coupon.max_usage.total,
          per_customer: -1,
          per_professional: coupon.max_usage.total,
          per_district: -1
        }),
        expires_at: moment(coupon.expires_at).toISOString()
      }
    }
  };
}

function addDistrictBody(payload) {
  const districtsIds = payload.districts.map(dist => dist.id);
  return {
    data: {
      type: "coupons",
      id: payload.coupon_id,
      relationships: {
        districts: {
          data: requestBody.build_includes(districtsIds, "districts")
        }
      }
    }
  };
}

export default {
  buildAttributes,
  createRequestBody,
  updateRequestBody,
  addDistrictBody,
  updateProfessionalCouponBody
};



// WEBPACK FOOTER //
// ./src/API/helpers/coupons.js